<template>
    <b-form-group :label-cols="labelCols" label-for="chooser" :label-class="labelClass">
        <template #label>
            {{ label }}<span v-if="required"> *</span>
            <HelpPopup v-if="helpHtml">
                <div v-html="helpHtml" />
            </HelpPopup>
        </template>
        <v-select id="chooser"
            ref="dropdown"
            v-model="object"
            class="style-chooser"
            :options="objects"
            :disabled="disabled"
            :select-on-tab="true"
            :clearable="clearable" />
    </b-form-group>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import TextUtils from "@/util/TextUtils";
import HelpPopup from "@/components/HelpPopup.vue";

@Component({
    name: "EnumSelector",
    components: { HelpPopup },
})
export default class EnumSelector extends Vue {
    @Prop() private value!: any;

    @Prop({
        default: false,
        type: Boolean,
    }) private required!: boolean;
    @Prop({
        default: "",
        type: String,
    }) private label: string | undefined;
    @Prop({
        default: false,
        type: Boolean,
    }) private disabled!: boolean;
    @Prop({
        default: false,
        type: Boolean,
    }) private clearable!: boolean;
    @Prop() private enumCodes!: any;
    /**
     * @displayNames: Its an array of objects of type {enum: Enum, name:string}
     * which allows us to manually indicate custom Names for a specific set of Enums.
     */
    @Prop() private displayNames!: Array<any>;

    /**
     * @elementsToDiscard: Array of Enums to indicate which enums
     * we would like to discard from the list.
     */
    @Prop() private elementsToDiscard!: Array<any>;
    @Prop(Number) readonly labelCols: number | undefined;
    /**
     * Extra label classes. Because this group sets label-for, BootstrapVue renders a plain <label>
     * rather than the <legend class="col-form-label"> it gives a label-for-less group, which leaves
     * the control sitting ~6px below plain b-form-group inputs beside it. Callers sharing a row with
     * those pass "col-form-label pt-0" to line up.
     */
    @Prop({ default: "", type: String }) private labelClass!: string;
    @Prop({ default: null, type: String }) private helpHtml: string | null | undefined;

    private enumFullDisplayName: Array<any> = [];

    get object(): string {
        //Receive enum, return Display Name
        const res = this.enumFullDisplayName.find(el => el.enum == this.value);
        return res?.fullDisplayName ?? "";
    }

    set object(val: string) {
        //Receive Display Name, return enum
        const enumNameEl: any = this.enumFullDisplayName.find((p: any) => p.fullDisplayName == val);
        this.$emit('input', enumNameEl?.enum);
    }

    get objects(): string[] {
        return this.stringsFromEnum(this.enumCodes);
    }

    stringsFromEnum(value: any): string[] {
        const strings: string[] = [];
        this.enumFullDisplayName = [];
        for (const n in value) {
            if (typeof value[n] === "number" && typeof n === "string") {
                const discard = this.elementsToDiscard?.some(el => el == value[n]);
                if (!discard) {
                    let name = '';
                    const dispName = this.displayNames?.find(dis => dis.enum == value[n]);
                    if (dispName) {
                        name = dispName?.name;
                    } else {
                        name = TextUtils.camelCaseToNormal(n);
                    }

                    const fullDisplayName = `${value[n]} - ${name}`;
                    strings.push(fullDisplayName);
                    this.enumFullDisplayName.push({
                        enum: value[n],
                        fullDisplayName,
                    });
                }
            }
        }
        return strings;
    }

    public focus() {
        (this.$refs.dropdown as any).$refs.search.focus();
    }

}
</script>

<style scoped>
</style>
